import { useId } from "react";

const MARK_PATH =
  "M420.4,10.72c-98.2,0-179.41,73.2-196.45,166.48h-3.63C203.29,83.92,122.08,10.72,23.88,10.72h-13.54v64.65h13.54c115.37,0,154.8,58.84,165.93,148.94h64.65c11.12-90.1,50.56-148.94,165.93-148.94h13.54V10.72h-13.54Z";
const LIVE_SWEEP_SECONDS = 4;

/**
 * The Ask Nexus mark: the Adge mark filled with the aurora gradient. Decorative; the label sits beside it.
 * `isLive` sweeps the colours across it while Ask Nexus is working, as the prototype's live mark does.
 */
export function AskNexusMark({ className, isLive = false }: { className?: string; isLive?: boolean }) {
  // useId can contain characters that break a url(#…) reference.
  const gradientId = `ask-nexus-aurora-${useId().replace(/[^a-zA-Z0-9_-]/g, "")}`;
  const isAnimated = isLive && !prefersReducedMotion();
  return (
    <svg className={className} viewBox="0 0 444.27 235.03" aria-hidden="true" focusable="false">
      <defs>
        <linearGradient
          id={gradientId}
          x1="0"
          y1="0"
          x2="1"
          y2={isLive ? "0" : "1"}
          spreadMethod={isLive ? "reflect" : "pad"}
        >
          <stop offset="0" stopColor="#FB923C" />
          <stop offset=".32" stopColor="#F87171" />
          <stop offset=".66" stopColor="#A78BFA" />
          <stop offset="1" stopColor="#60A5FA" />
          {isAnimated ? (
            <animateTransform
              attributeName="gradientTransform"
              type="translate"
              values="0 0;1 0;0 0"
              dur={`${LIVE_SWEEP_SECONDS}s`}
              repeatCount="indefinite"
            />
          ) : null}
        </linearGradient>
      </defs>
      <path fill={`url(#${gradientId})`} d={MARK_PATH} />
    </svg>
  );
}

/** SVG animation ignores the CSS media query, so the preference is read here. */
function prefersReducedMotion(): boolean {
  return typeof window !== "undefined" && window.matchMedia?.("(prefers-reduced-motion: reduce)").matches === true;
}
